import React, { useState } from 'react';
import SweetAlert from "react-bootstrap-sweetalert";
import { deleteAgendaRoute } from "../../../api/casp/agenda";
import { toast } from "react-toastify";
import { useSelector } from 'react-redux';
import { t } from 'i18next';
import { withTranslation } from 'react-i18next';


const SweetAlertComponent = ({ cancelSweetAlert, refresh,openDeleteAgendaModal,deleteAgendaDate, t}) => {
    const loggedInUser = useSelector((state) => state.Profile.user);

    const deleteAgenda= async (deleteAgendaId)=>{
        try {
            const response =  await deleteAgendaRoute(deleteAgendaId, {companyId: loggedInUser.company.id});
            if (response.statusCode === 200) {
             toast.success(response.data.message);
             
             cancelSweetAlert()
             refresh(deleteAgendaDate, 'delete')
           } else {
             toast.error(response.data.message);
            
           }
        } catch (error) {
            console.log(error);
        }
    
    }
    return (
        <React.Fragment>
             <SweetAlert
                    title={t("Are you sure you want to delete the course?")}
                    warning
                    showCancel                                                           
                    confirmBtnText={t("OK")}
                    cancelBtnText={t("Cancel")}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => {                                     
                        deleteAgenda(openDeleteAgendaModal.agendaId)                                                                      
                    }}
                    onCancel={() => {                                                 
                      cancelSweetAlert()
                    }}>
                </SweetAlert>
        </React.Fragment>
    )
}
export default withTranslation() (SweetAlertComponent);